import {
  BackgroundColors,
  PositiveColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles<
  string,
  { pricingCardWidth?: string; pricingCardHeight?: string }
>(
  {
    root: {
      padding: [Spacings.s40, Spacings.s32, Spacings.s72],
      boxShadow: `inset 0 0 0 1px ${BackgroundColors.tint3}`,
      position: 'relative',
      textAlign: 'center',
      overflow: 'hidden',
      color: TextColors.base,
      maxWidth: 480,
      width: ({ pricingCardWidth }) => pricingCardWidth && `${pricingCardWidth}px`,
      height: ({ pricingCardHeight }) => pricingCardHeight && `${pricingCardHeight}px`,
      '@media screen and (max-width: 1440px)': {
        minWidth: ({ pricingCardWidth }) => (pricingCardWidth ? `${pricingCardWidth}px` : 400),
      },
      '@media screen and (max-width: 1280px)': {
        '&&': {
          minWidth: 'auto',
        },
      },
      '@media screen and (max-width: 425px)': {
        '&&': {
          width: '100%',
        },
      },

      '&::before': {
        backgroundColor: ({ theme: { color } }: any) => color,
        position: 'absolute',
        display: 'block',
        content: '""',
        width: '100%',
        height: 8,
        left: 0,
        top: 0,
      },

      '& > a, & > button': {
        cursor: 'pointer',
      },
    },
    name: {
      fontWeight: FontWeights.semibold,
      marginBottom: Spacings.s32,
      fontSize: FontSizes.s24,
      display: 'block',
      lineHeight: 1,
    },
    logo: {
      margin: [Spacings.s0, 'auto', Spacings.s32],
      display: 'block',
      width: 'auto',
      height: 24,
    },
    price: {
      fontWeight: FontWeights.bold,
      marginBottom: Spacings.s40,
      fontSize: FontSizes.s60,
      lineHeight: 1.2,
      '& small': {
        fontWeight: FontWeights.medium,
        fontSize: FontSizes.s24,
        lineHeight: 1.4,
      },
    },
    note: {
      fontWeight: FontWeights.semibold,
      marginTop: Spacings.s16,
      fontSize: FontSizes.s14,
      lineHeight: 1.4,
      minHeight: 40,
    },
    separator: {
      margin: [Spacings.s8, Spacings.s0, Spacings.s24],
      backgroundColor: TextColors.tint3,
      height: 1,
    },
    title: {
      fontWeight: FontWeights.semibold,
      marginBottom: Spacings.s8,
      fontSize: FontSizes.s20,
      color: PositiveColors.text.default,
      lineHeight: 1.4,
    },
    description: {
      fontWeight: FontWeights.medium,
      fontSize: FontSizes.s16,
      lineHeight: 1.5,
    },
    cmsDescription: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'left',
      marginTop: Spacings.s16,
    },
  },
  { name: 'pa-monetization-pricing-card' },
);

export default useStyles;
